import {FACTIONS} from "../../../constants/factions";

export const ELVES_QUOTES = [{
  quote: 'Моя стрела уже в воздухе, пока ты думаешь, с какой ноги встать',
  author: 'Аэлэндриль Тенестрел, верховный эльф-маршал Дальних рощ',
  factionId: FACTIONS.ELVES
}, {
  quote: 'Мы не тратим стрелы. Мы тратим время врага, а стрелы — только подтверждение, что время вышло',
  author: 'Лаурелин Ветрострелая, эльф-смотрительница Тетивы Запада',
  factionId: FACTIONS.ELVES
}, {
  quote: 'Ты слышал свист? Это не ветер. Это твоя жизнь пролетела мимо уха. В следующий раз не пролетит',
  author: 'Нимфалия Шепчущая, эльф-куратор Теней листвы',
  factionId: FACTIONS.ELVES
}, {
  quote: 'Меткость — это терпение',
  author: 'Таларион Кленолист, эльф-префект Скрытых высот',
  factionId: FACTIONS.ELVES
}, {
  quote: 'Стрела не спрашивает, зачем ты встал на её пути',
  author: 'Келеборн Роговой, старший эльф-рейнджер Бесшумной стражи',
  factionId: FACTIONS.ELVES
}, {
  quote: 'Секрет не в том, чтобы убивать издалека. А в том, чтобы убивать задолго до того, как враг увидит угрозу',
  author: 'Элрос Ветвеплет, эльф-квестор Колчанных запасов ',
  factionId: FACTIONS.ELVES
}, {
  quote: 'Мы знаем, где ты будешь через мгновение. И пускаем стрелу туда',
  author: 'Нимродель Подлесковая, старший эльф-эдил Серебряного леса',
  factionId: FACTIONS.ELVES
}, {
  quote: 'Бег не спасет их, а лишь сделает более интересными мишенями',
  author: 'Эльданор Хладнокровный, эльф-магистр Прицельного молчания',
  factionId: FACTIONS.ELVES
}]